import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'

import { cn } from '@/lib/utils'

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>

export const FormLabel = forwardRef<ComponentRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, ...props }, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn('text-sm text-gray-700 select-none', className)} {...props} />
  )
)
